import React, { useEffect } from "react";

// CSS
import "./order-page.css";

// Sections
import Cart from "../../components/Cart/Cart";
import OrderForm from "../../components/OrderForm/OrderForm";

const Order = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page on mount
  }, []);
  return (
    <main className="order-page">
      <Cart />
      <OrderForm />
    </main>
  );
};

export default Order;
